import React from 'react';

// import UserProfileIcon from '../../../components/Icons/UserProfileIcon';
import Table from '../../../components/Table/Table';
import TableDateFormatter from '../../../components/Table/TableAccessories/TableDateFormatter';
import TableMoneyFormatter from '../../../components/Table/TableAccessories/TableMoneyFormatter';

// import ViewDetails from '../../../components/Table/TableAccessories/ViewDetails';
// import AuditReportView from '../../../components/Table/TableSliderViews/AuditReportView';

const RevenueCardList = () => {
  return (
    <Table
      tableTitle='REVENUE LIST'
      tableHeader={{
        Date: 'dateOfPurchase',
        'Partner Company': 'companyName',
        'Number of Lookups Purchased': 'unit',
        'Amount Generated': 'amount',
      }}
      tableDataSourceUrl='ba/v1/revenue/purchase-list'
      cellsCustomComp={{
        dateOfPurchase: <TableDateFormatter dataKey='dateOfPurchase' />,
        amount: <TableMoneyFormatter dataKey='amount' />,
      }}
      // moreOptionsComponents={[
      //   <ViewDetails
      //     key='view-user-details-2'
      //     label='View User Details'
      //     width='257px'
      //     icon={<UserProfileIcon />}
      //     sliderCompFn={(data: any) => (
      //       <AuditReportView data={data} statusKey='status' />
      //     )}
      //   />,
      // ]}
      // mobileCellComp={<UserProfileManagementCell />}
      // showPaginationControl={false}
    />
  );
};

export default RevenueCardList;
